import { IOktaMFAFactorLink } from "./IOktaMFAFactorLink";

export interface IOktaMFAFactorLinks {
  self: IOktaMFAFactorLink;
  verify: IOktaMFAFactorLink;
  user: IOktaMFAFactorLink;
}
